module.exports = __webpack_public_path__ + "img/products1.573f9b16.png";